import { COMMON_CONTENT } from './common';

export const SHOP_PAGE_CONTENT = {
  breadcrumb: 'Shop',
  filters: 'Filters',
  sort: {
    label: 'Sort by:',
    options: [
      { value: 'featured', label: 'Featured' },
      { value: 'newest', label: 'Newest' },
      { value: 'price-low', label: 'Price: Low to High' },
      { value: 'price-high', label: 'Price: High to Low' },
      { value: 'rating', label: 'Highest Rated' },
    ],
  },
  pagination: {
    previousLabel: 'Previous',
    nextLabel: 'Next',
  },
} as const;

export const SEARCH_PAGE_CONTENT = {
  title: 'Search Results',
  breadcrumb: 'Search Results',
  noResults: 'No Results Found',
  noResultsDescription: (query: string) => `We couldn't find anything matching "${query}".`,
  trySearching: 'Try searching for:',
  empty: {
    title: 'No friends found',
    description: 'Try different keywords to find your perfect match.',
    placeholder: COMMON_CONTENT.placeholders.search,
    popularSearches: 'Popular Searches',
  },
  suggestions: ['Teddy Bear', 'Bunny', 'New Arrivals', 'Gifts'],
  results: (count: number) => `Found ${count} adorable friends`,
  browseAll: 'Browse All Products',
} as const;
